// AUTO-GENERATED — DO NOT EDIT.
//
// Source of truth: V3/backend FastAPI app.routes + the DEP_HEADERS
// table in scripts/gen-route-headers.py. Regenerate with:
//
//   python scripts/gen-route-headers.py
//
// CI fails (.github/workflows/ci-codegen-drift.yml) if this file is
// stale relative to backend route additions. The matcher in
// api/client.ts imports these arrays directly, so adding a new
// authed backend route under a new path prefix is now
// auto-propagated to the frontend's auth-header attachment.

/**
 * Path prefixes whose backend routes require a Clerk bearer
 * (``Authorization: Bearer <jwt>``, sourced from Clerk's
 * ``useAuth().getToken()`` with a ``/dev/quickstart`` dev-token
 * fallback). Matches via ``path === prefix || path.startsWith(prefix + '/')``.
 */
export const TEACHER_AUTH_PATHS = [
  "/admin/access-log",
  "/admin/access-log.csv",
  "/admin/build-metrics",
  "/admin/contact",
  "/admin/dashboard",
  "/admin/incident-status",
  "/admin/mastery",
  "/admin/me",
  "/admin/modules",
  "/admin/onboarding",
  "/admin/ops/summary",
  "/admin/password-reset-requests",
  "/admin/plans",
  "/admin/roster/import",
  "/admin/settings",
  "/admin/students",
  "/classes",
  "/me/accept-dpa",
  "/me/accept-warranty",
  "/me/dpa-status",
  "/me/warranty-status",
  "/teacher/build-notices",
  "/teacher/classes",
  "/teacher/me",
] as const;

/**
 * Path prefixes whose backend routes require a student bearer
 * (``Authorization: Bearer <hs256>``, sourced from
 * ``localStorage.studentToken``).
 */
export const STUDENT_AUTH_PATHS = [
  "/auth/student-acknowledge-notice",
  "/auth/student-logout",
  "/auth/student-me",
  "/auth/student-set-password",
  "/dev/quickstart/start-assessment-prefilled",
  "/dev/quickstart/start-tutoring",
  "/sessions",
  "/student/enroll",
  "/student/me",
] as const;

/**
 * Path prefixes whose backend routes accept ANY authenticated
 * principal (student OR teacher/admin). The backing dep is
 * ``get_current_principal`` in ``routers/me_explain.py`` which
 * dispatches on the bearer token's unverified ``student_pk`` vs
 * ``sub`` claim. The frontend matcher checks this bucket BEFORE
 * the teacher/student buckets and attaches whichever token is
 * available (student token first — lighter check, no Clerk
 * roundtrip — falling back to dev teacher token then Clerk JWT).
 * See eehae#581.
 */
export const MULTI_ROLE_AUTH_PATHS = [
  "/me/explain-decision",
] as const;

/**
 * Path prefixes for ``/dev/*`` routes guarded by
 * ``require_dev_password``. The ``X-Dev-Password`` header is
 * sourced from ``localStorage.siteAccess`` (backend accepts
 * ``SITE_PASSWORD`` as the dev-password fallback per
 * ``routers/dev_common.py::_expected_dev_password``).
 */
export const DEV_PASSWORD_PATHS = [
  "/dev/classes",
  "/dev/openrouter-models",
  "/dev/provider",
  "/dev/sessions",
] as const;
